export class HttpError<ContextType> extends Error {
  public readonly name: string = 'HttpError';
  public readonly statusCode: number;

  constructor(
    public readonly status: number,
    public readonly message: string,
    public readonly context?: ContextType,
  ) {
    super(message);
    this.statusCode = status;
  }
}

export class BadRequestError<ContextType> extends HttpError<ContextType> {
  public readonly name: string = 'BadRequestError';

  constructor(
    public readonly message: string = 'Bad Request',
    public readonly context?: ContextType,
  ) {
    super(400, message, context);
  }
}

export class NotFoundError<ContextType> extends HttpError<ContextType> {
  public readonly name: string = 'NotFoundError';

  constructor(
    public readonly message: string = 'Not Found',
    public readonly context?: ContextType,
  ) {
    super(404, message, context);
  }
}
export class BadGatewayError<ContextType> extends HttpError<ContextType> {
  public readonly name: string = 'BadGatewayError';

  constructor(
    public readonly message: string = 'Bad Gateway',
    public readonly context?: ContextType,
  ) {
    super(502, message, context);
  }
}
